import React from 'react';
import { Chip } from '@mui/material';

import { APPLICATION_STATUS } from '../../utils/applicationStatus';

export const ApplicationStatusChip = ({ status }) => {
  const { label, color } = APPLICATION_STATUS[status] ?? APPLICATION_STATUS.new;

  return <Chip label={label} color={color} size="small" sx={{ fontWeight: 600 }} />;
};
